import React from 'react';
import { EventDetailTemplateOnlyImages } from '../../components/common/template/EventDetailTemplate';
import * as IMAGE from '../../lib/image/event/EventRefundImages';

const TITLE_REFUND = '100% 환불 안심제도';
const ID_REFUND = 'refund';
const PERIOD_REFUND = {
  startDate: '2023-06-26T00:00:00',
  endDate: '2024-08-31T23:59:59',
};

export const EVENT_DETAIL_REFUND = {
  title: TITLE_REFUND,
  period: PERIOD_REFUND,
  images: IMAGE.EVENT_DETAIL_REFUND,
};

export const EVENT_BANNER_REFUND = {
  id: ID_REFUND,
  period: PERIOD_REFUND,
  image: IMAGE.EVENT_BANNER_REFUND,
};

export const EVENT_COMPONENT_REFUND = {
  id: ID_REFUND,
  component: (
    <EventDetailTemplateOnlyImages
      event={EVENT_DETAIL_REFUND}
      key={ID_REFUND}
    />
  ),
};
